/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import './Row.scss';

const Row: FunctionComponent = (props): JSX.Element => {
    return <div className="row">{props.children}</div>;
};

Row.propTypes = {
    children: PropTypes.node,
};
export default Row;
